import React, { useContext } from "react";
import { QuizContext } from "../../App";

const ButtonsTabCreate = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;
  const styleLink = {
    marginBottom: "20px",
    color: theme === "dark"
      ? "#4da2f7"
      : "#0a70d6"
  };
  const styleOn = {
    marginBottom: "20px",
    color: theme === "dark"
      ? "#d0d2d4"
      : "#212529"
  };


  return (
    <>

      {quizContext.state.tabStatus === "right"
        ? <>
          <button
            className="tab-btn-link-left"
            style={styleLink}
            onClick={() => quizContext.dispatch({
              type: "switchTabLeft"
            })}
          >
            Create from xlsx file
          </button>
          <button
            className="tab-btn-on-right"
            style={styleOn}
          >
            Create from table
          </button>
        </>
        : <>
          <button
            className="tab-btn-on-left"
            style={styleOn}
          >
            Create from xlsx file
          </button>
          <button
            className="tab-btn-link-right"
            style={styleLink}
            onClick={() => quizContext.dispatch({
              type: "switchTabRight"
            })}
          >
            Create from table
          </button>
        </>
      }
    </>
  )
}

export default ButtonsTabCreate